import { EntryMethod } from '../../common/enumerations/entry-method';
import { ISelectedItem } from '../../common/interfaces/dtos/ISelectedItem';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { addLookedupItemToTransaction } from '../../home-page/business-logic/sale-mode-router';
import { getSalesKeypadState } from '../../sales-keypad/business-logic/sales-keypad-operations';
import { lookupItemById } from '../../items-list/business-logic/item-lookup';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';

export const sellPluItem = async (selectedItem: ISelectedItem): Promise<void> => {
  const { quantityEntered, isManualWeight, metricValue } = getSalesKeypadState();
  const itemInputData: IItemInputData = {
    itemId: selectedItem.selectedItemId,
    entryMethod: EntryMethod.Tapped,
    quantity: metricValue,
    quantityEntryMethod: quantityEntered ? EntryMethod.Keyed : EntryMethod.Automatic,
    isManualWeight: isManualWeight,
  };

  await withSpinner(async () => {
    const itemLookup = await lookupItemById({ data: itemInputData.itemId });
    await addLookedupItemToTransaction(itemInputData, itemLookup);
  });
};
